﻿import template from './default-page-logged-out-component.html';
class DefaultPageLoggedOutComponent {
    constructor() {
    }
}

export default { viewModel: DefaultPageLoggedOutComponent, template: template };

